import type { FaireProductEntity } from "../../entity_types/product";

export const atc_toast_6: FaireProductEntity = {
  token: "atc_toast_6",
  type: "product",
  name: "Cashews Rosemary Garlic",
  brandName: "P.Stash",
  imageUrl: "",
  priceDollars: 19.0,
  msrpDollars: 38.0,
  description: "Migrated search/ATC mock product",
  tags: ["search", "prototype"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
